export default "__VITE_ASSET__WQT6LTis__"